<template>
  <div id="dataBased"></div>
</template>
<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
export default {
  props: {
    geometricForm: {
      type: Boolean,
      default: () => true,
    },
    data: {
      type: Array,
    },
    axisAndSeries: {
      type: Array,
    },
    min: {
      type: Number,
      default: 0,
    },
    max: {
      type: Number,
      default: 30,
    },
    baseInterval: {
      type: Object,
      default() {
        return {
          timeUnit: "hour",
          count: 1,
          chart: undefined,
          valueAxis:undefined
        };
      },
    },
  },
  mounted() {
    this.createChart();
  },

  methods: {
    createChart() {
      am4core.useTheme(am4themes_animated);
      this.chart = am4core.create("dataBased", am4charts.XYChart);
      this.chart.paddingRight = 20;
      this.chart.language.locale = "pt_BR";
      this.chart.dateFormatter.language = new am4core.Language();
      this.chart.dateFormatter.language.locale = "pt_BR";
      this.chart.colors.step = 2;
      this.chart.data = this.data;

      var dateAxis = this.chart.xAxes.push(new am4charts.DateAxis());

      dateAxis.renderer.minGridDistance = 20;
      dateAxis.baseInterval = {
        timeUnit: this.baseInterval["timeUnit"],
        count: this.baseInterval["count"],
      };
      this.valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      this.valueAxis.renderer.line.strokeOpacity = 1;
      this.valueAxis.renderer.line.strokeWidth = 2;
      this.valueAxis.min = this.min;
      this.valueAxis.max = this.max;
      this.valueAxis.strictMinMax = true;
      dateAxis.renderer.minGridDistance = 100;
     

      this.axisAndSeries.forEach((element) => {
        this.createAxisAndSeries(
          element.field,
          element.name,
          element.opposite,
          element.geometric
        );
      });
      this.chart.legend = new am4charts.Legend();
      this.chart.legend.position = "top";
      // Add cursor
      this.chart.cursor = new am4charts.XYCursor();
    },
      createAxisAndSeries(field, name, opposite, geometric) {
        this.valueAxis.renderer.grid.template.strokeWidth = 0;

        var series = this.chart.series.push(new am4charts.LineSeries());

        series.dataFields.valueY = field;
        series.dataFields.dateX = "date";
        series.strokeWidth = 2;
        series.yAxis = this.valueAxis;
        series.name = name;
        series.tooltipText = "{name}: [bold]{valueY}[/]";
        series.tensionX = 0.8;
        series.showOnInit = true;
      let geometricForm = this.geometricForm

        if (geometricForm) {
          let interfaceColors = new am4core.InterfaceColorSet();
          let bullet = series.bullets.push(new am4charts.Bullet());
          let triangle = bullet.createChild(am4core.Triangle);
          let rectangle = bullet.createChild(am4core.Rectangle);
          switch (geometric) {
            case "triangle":
              series.stroke = am4core.color("#ff0000");
              series.tooltip.getFillFromObject = false;
              series.tooltip.background.fill = am4core.color("#F2C94C");
              bullet.width = 12;
              bullet.height = 12;
              bullet.horizontalCenter = "middle";
              bullet.verticalCenter = "middle";

              triangle.stroke = interfaceColors.getFor("background");
              triangle.fill = am4core.color("#F2C94C");
              series.stroke = am4core.color("#F2C94C");
              this.chart.tooltip.label.fill = am4core.color("#f00");
              triangle.strokeWidth = 2;
              triangle.direction = "top";
              triangle.width = 12;
              triangle.height = 12;

              break;
            case "rectangle":
              bullet.width = 10;
              bullet.height = 10;
              bullet.horizontalCenter = "middle";
              bullet.verticalCenter = "middle";
              series.tooltip.getFillFromObject = false;
              series.tooltip.background.fill = am4core.color("#F2994A");
              rectangle.stroke = interfaceColors.getFor("background");
              rectangle.fill = am4core.color("#F2994A");
              series.stroke = am4core.color("#F2994A");
              rectangle.strokeWidth = 2;
              rectangle.width = 10;
              rectangle.height = 10;
              break;
            case "pipe":
              bullet.width = 10;
              bullet.height = 10;
              bullet.horizontalCenter = "middle";
              bullet.verticalCenter = "middle";

              rectangle.stroke = interfaceColors.getFor("background");
              rectangle.fill = am4core.color("#EB5757");
              series.stroke = am4core.color("#EB5757");
              series.tooltip.getFillFromObject = false;
              series.tooltip.background.fill = am4core.color("#EB5757");
              rectangle.strokeWidth = 2;
              rectangle.width = 5;
              rectangle.height = 15;
              break;
            default:
              bullet.stroke = interfaceColors.getFor("background");
              bullet.fill = am4core.color("#27AE60");
              series.stroke = am4core.color("#27AE60");
              series.tooltip.getFillFromObject = false;
              series.tooltip.background.fill = am4core.color("#27AE60");
              bullet.strokeWidth = 2;
              break;
          }
        }

        this.valueAxis.renderer.line.strokeOpacity = 1;
        this.valueAxis.renderer.line.strokeWidth = 2;
        this.valueAxis.renderer.line.stroke = series.stroke;
        this.valueAxis.renderer.labels.template.fill = series.stroke;
        this.valueAxis.renderer.opposite = opposite;
      }
  },
};
</script>
<style scoped lang="scss">
#dataBased {
  height: 100%;
  min-height: 400px;
}
</style>